import React, { useEffect, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col } from "react-bootstrap";

import ConsultaFinalidade from '../../../../../lib/json/consultas/Finalidade.json'
import ConsultaGrupoProduto from '../../../../../lib/json/consultas/GrupoProduto.json'

import LoadingSpinner from "../../../../components/LoadinSpinner";
import InputGeral from "../../../../components/InputGeral/Index";
import { useNavigate, useParams } from "react-router-dom";
import SubmitForm from "../../../../components/SubmitForm";
import { ErroMsg, SucessoMsg } from "../../../../contents/VariaveisGlobais";
import { toast } from "react-toastify";
import ConsultaTotvs from "../../../../../backend/ConsultaTotvs";
import ConsumoTOTVS_POST from "../../../../../backend/ConsumoTotvs";
import TitlePageTotvs from "../../../../components/TitlePageTotvs";
import { ConsultaTotvsEmpresa } from "../../../../../backend/ConsultaTotvsEmpresa";
import SelectDinamico from "../../../../components/SelectDinamico";

function FichaFinalidade(){
    const navigate = useNavigate();
    const isFormVisual = window.location.href.includes('Visualizar');
    
    // define a exibição do Loading
    var [carregar, setCarregar] = useState(false);
    const [disabledForm, setDisabledForm] = useState(isFormVisual);

    const { idFinalidade, empresaFilialCompras } = useParams();
    
    const [empresaFilialSelect, setEmpresaFilialSelect] = useState(empresaFilialCompras);
    const [empresaFilial, setEmpresaFilial] = useState(empresaFilialCompras);

    // Consulta do grid
    var consultaDefault  = ConsultaFinalidade.consulta + (idFinalidade ? ` WHERE D_E_L_E_T_ <> '*' AND DHK_CODIGO = '${idFinalidade}'` : '');

    var [campoCodigo, setCampoCodigo]   = useState('0');
    var [campoDescricao, setCampoDescricao]   = useState("");
    var [campoPrazoSLA, setCampoPrazoSLA]     = useState("0");
    var [campoProdutoDe, setCampoProdutoDe]   = useState("");
    var [campoProdutoAte, setCampoProdutoAte] = useState("");
    var [campoGruposProduto, setCampoGruposProduto] = useState([]);

    useEffect(() => {
        if (idFinalidade){
            loadFinalidade();
        }
    }, []);

    // Processa consulta do grid
    const loadFinalidade = async () => {
        setCarregar(true);
        
        
        var retConsulta = await ConsultaTotvsEmpresa( consultaDefault, ConsultaFinalidade.tabelas );
        
        if (retConsulta.data){
            setCampoCodigo(retConsulta.data[0].DHK_CODIGO);
            setCampoDescricao(retConsulta.data[0].DHK_DESCR);
            setCampoPrazoSLA(retConsulta.data[0].DHK_XDSLA);
            setCampoProdutoDe(retConsulta.data[0].DHK_XPRDIN);
            setCampoProdutoAte(retConsulta.data[0].DHK_XPRDFN);
            
            if (retConsulta.data[0].DHK_XGRPRD.trim()){
                const gruposSelecionados = retConsulta.data[0].DHK_XGRPRD.trim().split(';').map( (item) => {return {value: item, label: '' } }).filter( item => item.value !== '' )
                setCampoGruposProduto(gruposSelecionados);
            }
        }
        
        setCarregar(false);
    }

    const handleSalvar = async() =>{
        // Verificar se todos os campos obrigatórios foram preenchidos
        if (!campoDescricao) {
            toast.warning('O prenchimento do campo é obrigatório.');
            return;
        }

        const cJSON = { 
            ACAO: !idFinalidade ? 'INCLUIR' : 'ALTERAR',
            DHK_CODIGO: campoCodigo,
            DHK_DESCR: campoDescricao,
            DHK_XDSLA: campoPrazoSLA,
            DHK_XPRDIN: campoProdutoDe,
            DHK_XPRDFN: campoProdutoAte,
            DHK_XGRPRD: campoGruposProduto.length > 0 ? campoGruposProduto.map( (item) => item.value ).join(';')+';' : ''
        }

        setCarregar(true);
        const oRetorno = await ConsumoTOTVS_POST('FINALIDADE', cJSON, empresaFilial)

        if (oRetorno.error === '00'){
            SucessoMsg(oRetorno.description)
        }else{
            ErroMsg(oRetorno.description)
        }
    }

    const handleEmpresaFilial = (e) => {
        setEmpresaFilialSelect(e)
        setEmpresaFilial(e.value)
    }

    return (
        <>
            <Row>
                <LoadingSpinner isLoading={carregar}/>
                <Col md="12" xs="12">
                    <TitlePageTotvs 
                        text="Finalidade" 
                        empresa={empresaFilialSelect} 
                        empresaFilial={empresaFilial} 
                        changeEmpresa={handleEmpresaFilial}
                    />
                </Col>
            </Row>
            { empresaFilial &&
                <Row>
                    <Col md="2" xs="12">
                        <InputGeral 
                            label="Código"
                            tipo='text'
                            value={campoCodigo}  // Define o valor do campo com base no estado
                            onChange={(e) => setCampoCodigo(e.target.value)}
                            disabled={true}                    
                        />
                    </Col>

                    <Col md="7" xs="12">
                        <InputGeral 
                            label="Descrição"
                            tipo='text'
                            value={campoDescricao}  // Define o valor do campo com base no estado
                            onChange={(e) => setCampoDescricao(e.target.value)}
                            disabled={disabledForm}
                        />
                    </Col>

                    <Col md="3" xs="12">
                        <InputGeral 
                            label="Prazo SLA (Dias)"
                            tipo='numero'
                            step={1}
                            value={campoPrazoSLA}  // Define o valor do campo com base no estado
                            onChange={(e) => setCampoPrazoSLA(e.target.value)}
                            disabled={disabledForm}
                        />
                    </Col>
                    
                    {/* <Col md="6" xs="12">
                        <InputGeral 
                            label="Produto de:"
                            tipo='text'
                            onChange={(e) => setCampoProdutoDe( e.target.value)}
                            value={campoProdutoDe}
                            disabled={disabledForm}
                            max={30}
                        />
                    </Col>

                    <Col md="6" xs="12">
                        <InputGeral 
                            label="Produto até:"
                            tipo='text'
                            onChange={(e) => setCampoProdutoAte( e.target.value)}
                            value={campoProdutoAte}
                            disabled={disabledForm}
                            max={30}
                        />
                    </Col> */}

                    <Col md="12" xs="12">
                        <SelectDinamico 
                            label={"Grupos de Produto Habilitados"}
                            isMultiplo={true}
                            disabled={disabledForm}
                            EmpresaLogada={empresaFilial}
                            consulta={ConsultaGrupoProduto.consulta}
                            tabela={ConsultaGrupoProduto.tabelas}
                            cText="BM_GRUPO + ' - ' + item.BM_DESC"
                            cValue="BM_GRUPO"
                            campoValue={campoGruposProduto}
                            onchange={(e) => setCampoGruposProduto(e)}
                        />
                    </Col>
                </Row>
            }
            
            <SubmitForm 
                onSave={ disabledForm ? null : handleSalvar}
                onCancel={ disabledForm ? null : "handleCancelar"}
                onVoltar={ disabledForm ? "handleVoltar" : null}
            />
        </>
    );
}

export default FichaFinalidade;